/* Ardor Table Cover Designer: the AI design drawer ("AI design" on the tool rail). Ardor Printing. New Oct 12, 2026 (TT-CORE),
made from the flag designer's drawer (assets/ardor-flag-ai.js, unchanged).
Builds its form inside the drawer panel that ardor-table-layers.js adds ([data-afa-host]). Uses the AI server the AI banner
generator uses (ws-idea-api, banner mode, no server change): POST /api/banner/logo, /api/banner/generate, /api/banner/final,
GET /api/banner/quota, with the same visitor id / email (localStorage wsIdeaVisitor / wsIdeaEmail) and the same invisible
Cloudflare Turnstile check, so tries are shared with the AI generator pages.
It designs the panel being edited (front, top, a side or the back; the front from the Whole cover view): the request is
the panel's upright size in feet (widthFt x heightFt; a round top asks for the circle's square). The picked design is
made print-ready (/final) and handed to ArdorTableLayers.placeAi(), which fits it in the panel, extends its own edges to
fill the rest and drops it on that panel (table/core/HANDOFF-CORE.md). */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__afa) return;
  root.__afa = true;

  var CONF = {};
  try { CONF = JSON.parse(root.querySelector('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  var API_BASE = String(CONF.ideaApi || 'https://ws-idea-api.dayne-18a.workers.dev').replace(/\/+$/, '');
  var SITEKEY = String(CONF.turnstile || '');
  var AI_PAGE = String(CONF.ideasUrl || '/pages/ai-table-throw-generator');
  var LIMITS = { headline: 60, subline: 80, details: 120, notes: 300 };
  var STYLES = [['bold', 'Bold'], ['clean', 'Clean'], ['fun', 'Fun'], ['elegant', 'Elegant'], ['vintage', 'Vintage'], ['event', 'Event']];
  var MAX_LOGO_PX = 1536, MAX_LOGO_BYTES = 8 * 1024 * 1024;

  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) {} return null; }
  var visitor = store('wsIdeaVisitor');
  if (!visitor || !/^[a-zA-Z0-9_-]{8,64}$/.test(visitor)) {
    visitor = ((window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2)).replace(/[^a-zA-Z0-9_-]/g, '');
    store('wsIdeaVisitor', visitor);
  }
  var email = store('wsIdeaEmail') || '';
  var S = { style: 'bold', logo: null, logoId: '', busy: false, left: null, hasEmail: false, emailTries: 10, batch: null, timer: 0 };
  var ui = {};

  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function $(s, r) { return (r || ui.host || document).querySelector(s); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function clean(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e); }
  function track(name, data) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {} }
  function FA() { return window.ArdorTableAPI; }

  // ---------- the panel being designed: what to ask the AI for ----------
  // The panel being edited (the front from the Whole cover view), upright, so the design is never turned (rot 0).
  function plan() {
    var A = FA(), c = A.cfg(), faces = A.faces ? A.faces() : ['front'];
    var panel = A.editFace() || (faces.indexOf('front') >= 0 ? 'front' : faces[0]);
    var box = A.faceBox(panel), info = A.panelInfo ? A.panelInfo(panel) : null;
    var ft = function (n) { return Math.max(0.5, Math.min(200, Math.round(n / 12 * 100) / 100)); };
    return { c: c, panel: panel, panelName: (info && info.name) || 'Front', rot: 0, widthFt: ft(box.w), heightFt: ft(box.h), wIn: box.w, hIn: box.h, name: A.coverName ? A.coverName() : c.key };
  }

  // ---------- server ----------
  function api(path, body, ms) {
    var opts = {};
    if (body instanceof FormData) { opts.method = 'POST'; opts.body = body; }
    else if (body) { opts.method = 'POST'; opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(body); }
    var ctl = window.AbortController ? new AbortController() : null, t = 0;
    if (ctl) { opts.signal = ctl.signal; t = setTimeout(function () { ctl.abort(); }, ms || 180000); }
    return fetch(API_BASE + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        clearTimeout(t);
        if (!j || typeof j !== 'object') j = {};
        if (r.status === 402 && !j.error) j.error = 'need_email';
        if (!r.ok) { if (!j.error) j = { ok: false, error: 'server', message: 'Something went wrong on our side. Please try again.' }; j.ok = false; }
        return j;
      });
    }, function (e) {
      clearTimeout(t);
      return e && e.name === 'AbortError' ? { ok: false, error: 'timeout', message: 'This is taking longer than usual. Please try again.' } : { ok: false, error: 'network', message: 'Check your connection and try again.' };
    });
  }
  function withEmail(b) { if (S.hasEmail && email) b.email = email; return b; }
  function quota() {
    var q = 'visitor=' + encodeURIComponent(visitor) + (email ? '&email=' + encodeURIComponent(email) : '');
    return fetch(API_BASE + '/api/banner/quota?' + q).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.ok) { S.left = j.bannersLeft; S.hasEmail = !!j.hasEmail; S.emailTries = j.emailBanners || S.emailTries; if (j.enabled === false) S.off = true; }
      syncQuota();
    }).catch(function () {});
  }

  // ---------- Turnstile: explicit render, invisible, a fresh token for every request ----------
  var tsReady = null, tsWidget = null, tsResolve = null;
  function loadTurnstile() {
    if (!SITEKEY) return Promise.resolve(false);
    if (tsReady) return tsReady;
    tsReady = new Promise(function (res) {
      if (window.turnstile && window.turnstile.render) { res(true); return; }
      window.afaTurnstileLoaded = function () { res(true); };
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=afaTurnstileLoaded';
      s.async = true; s.defer = true;
      s.onerror = function () { res(false); };
      document.head.appendChild(s);
    });
    return tsReady;
  }
  function botToken() {
    return loadTurnstile().then(function (ok) {
      if (!ok || !window.turnstile) return '';
      return new Promise(function (res) {
        tsResolve = res;
        var take = function (t) { var r = tsResolve; if (r) { tsResolve = null; r(t || ''); } };
        try {
          if (tsWidget === null) tsWidget = window.turnstile.render($('[data-afa-ts]'), { sitekey: SITEKEY, execution: 'execute', appearance: 'interaction-only', callback: take, 'error-callback': function () { take(''); } });
          else window.turnstile.reset(tsWidget);
          window.turnstile.execute(tsWidget);
        } catch (e) { take(''); }
        setTimeout(function () { if (tsResolve === res) take(''); }, 45000);
      });
    });
  }

  // ---------- logo: any picture, made a PNG up to 1536 px for the AI ----------
  function toPng(file) {
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () {
        var w = im.naturalWidth || 800, h = im.naturalHeight || 800, k = Math.min(1, MAX_LOGO_PX / Math.max(w, h));
        var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(w * k)); cv.height = Math.max(1, Math.round(h * k));
        cv.getContext('2d').drawImage(im, 0, 0, cv.width, cv.height);
        URL.revokeObjectURL(u);
        cv.toBlob(function (b) { if (b) res(b); else rej(new Error('png')); }, 'image/png');
      };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('decode')); };
      im.src = u;
    });
  }
  function uploadLogo() {
    if (!S.logo) return Promise.resolve('');
    if (S.logoId) return Promise.resolve(S.logoId);
    return toPng(S.logo).then(function (b) {
      if (b.size > MAX_LOGO_BYTES) throw { message: 'Your logo is too big. Try a smaller file.' };
      var fd = new FormData(); fd.append('file', b, 'logo.png'); fd.append('visitor', visitor);
      return api('/api/banner/logo', fd, 60000);
    }, function () { throw { message: 'We couldn\'t read that logo. Upload a PNG, JPG or SVG file.' }; }).then(function (j) {
      if (!j.ok || !j.logoId) throw j;
      S.logoId = j.logoId; return j.logoId;
    });
  }

  // ---------- UI ----------
  function build(host) {
    ui.host = host;
    host.innerHTML =
      '<div class="afa">' +
      '<p class="abl-help afa-lead">Type your words and pick a style. Our AI draws 4 designs for the <b data-afa-panel></b> of your table cover. Tap one to put it on that panel, then move, resize or copy it to other panels.</p>' +
      '<p class="abl-help afa-size" data-afa-size></p>' +
      '<label class="afa-field"><span>Main words <em>(required)</em></span><input class="abl-input afa-in" data-afa-line="headline" maxlength="' + LIMITS.headline + '" placeholder="For example: GRAND OPENING" autocomplete="off"></label>' +
      '<label class="afa-field"><span>Second line <em>(optional)</em></span><input class="abl-input afa-in" data-afa-line="subline" maxlength="' + LIMITS.subline + '" placeholder="For example: Coffee, pastries and more" autocomplete="off"></label>' +
      '<label class="afa-field"><span>Details <em>(optional)</em></span><input class="abl-input afa-in" data-afa-line="details" maxlength="' + LIMITS.details + '" placeholder="Phone, website or address" autocomplete="off"></label>' +
      '<div class="afa-field"><span>Style</span><div class="afa-styles" data-afa-styles></div></div>' +
      '<label class="afa-field"><span>Colors, pictures or mood <em>(optional)</em></span><textarea class="abl-input afa-in afa-notes" rows="2" data-afa-notes maxlength="' + LIMITS.notes + '" placeholder="For example: red and white, a coffee cup"></textarea></label>' +
      '<div class="afa-field"><span>Your logo <em>(optional)</em></span><div class="afa-logo"><input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" data-afa-logo-in hidden><button type="button" class="afa-btn afa-btn--ghost" data-afa-logo-btn>Add your logo</button><span class="afa-logo__name" data-afa-logo-name></span><button type="button" class="afa-x" data-afa-logo-x hidden aria-label="Remove the logo">&times;</button></div></div>' +
      '<div class="afa-gate" data-afa-gate hidden><p class="abl-help">You\'ve used today\'s free tries. Add your email for <span data-afa-gate-n>10</span> tries a day.</p><div class="afa-gate__row"><input class="abl-input afa-in" type="email" data-afa-email placeholder="you@example.com" autocomplete="email" aria-label="Your email"><button type="button" class="afa-btn" data-afa-email-go>Continue</button></div></div>' +
      '<p class="afa-err" data-afa-err role="alert" hidden></p>' +
      '<button type="button" class="afa-btn afa-btn--go" data-afa-go>Design this panel</button>' +
      '<p class="afa-quota" data-afa-quota></p>' +
      '<div class="afa-status" data-afa-status aria-live="polite" hidden></div>' +
      '<div class="afa-results" data-afa-results></div>' +
      '<div class="afa-ts" data-afa-ts></div>' +
      '<p class="abl-help afa-more">Want more room to try ideas? <a data-afa-page href="' + esc(AI_PAGE) + '">Open the full AI generator</a>.</p>' +
      '</div>';
    var st = $('[data-afa-styles]');
    STYLES.forEach(function (s) {
      var b = el('button', 'afa-chip', esc(s[1])); b.type = 'button'; b.setAttribute('data-afa-s', s[0]); b.setAttribute('aria-pressed', s[0] === S.style ? 'true' : 'false');
      st.appendChild(b);
    });
    host.addEventListener('click', onClick);
    $('[data-afa-logo-in]').addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0]; e.target.value = '';
      if (!f) return;
      if (f.size > 30 * 1024 * 1024) { showErr('That logo file is too big. Try one under 30 MB.'); return; }
      S.logo = f; S.logoId = ''; syncLogo();
    });
    host.addEventListener('input', function () { showErr(''); });
    syncDir(); syncLogo(); quota();
    root.addEventListener('ardor:table-view', syncDir);
    root.addEventListener('click', function (e) { if (e.target.closest('[data-abl-tool="ai"], [data-abl-idea]')) setTimeout(syncDir, 0); });
  }
  function onClick(e) {
    var b = e.target.closest('button, a'); if (!b) return;
    if (b.hasAttribute('data-afa-s')) { S.style = b.getAttribute('data-afa-s'); [].forEach.call(ui.host.querySelectorAll('[data-afa-s]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); return; }
    if (b.hasAttribute('data-afa-logo-btn')) { $('[data-afa-logo-in]').click(); return; }
    if (b.hasAttribute('data-afa-logo-x')) { S.logo = null; S.logoId = ''; syncLogo(); return; }
    if (b.hasAttribute('data-afa-go')) { generate(); return; }
    if (b.hasAttribute('data-afa-email-go')) { useEmail(); return; }
    if (b.hasAttribute('data-afa-use')) { useDesign(b.getAttribute('data-afa-use')); return; }
    if (b.hasAttribute('data-afa-page')) { var p = plan(); b.href = AI_PAGE + (AI_PAGE.indexOf('?') < 0 ? '?' : '&') + 'cover=' + encodeURIComponent(p.c.key) + '&panel=' + encodeURIComponent(p.panel); }
  }
  // the panel the drawer designs, and its size
  function syncDir() {
    if (!ui.host || !FA()) return;
    var p = plan();
    var f = $('[data-afa-panel]'); if (f) f.textContent = p.panelName.toLowerCase();
    var z = $('[data-afa-size]'); if (z) z.textContent = p.panelName + ': ' + Math.round(p.wIn * 4) / 4 + ' x ' + Math.round(p.hIn * 4) / 4 + ' in (width x height), on your ' + String(p.name).toLowerCase() + '.';
  }
  function syncLogo() {
    $('[data-afa-logo-name]').textContent = S.logo ? S.logo.name : '';
    $('[data-afa-logo-x]').hidden = !S.logo;
    $('[data-afa-logo-btn]').textContent = S.logo ? 'Change logo' : 'Add your logo';
  }
  function syncQuota() {
    var q = $('[data-afa-quota]'); if (!q) return;
    if (S.off) { q.textContent = 'AI design is resting right now. Please try again later.'; $('[data-afa-go]').disabled = true; return; }
    if (S.left == null) { q.textContent = ''; return; }
    q.textContent = S.left > 0 ? (S.left + (S.left === 1 ? ' try' : ' tries') + ' left today' + (S.hasEmail ? '' : ' · 4 designs each · no sign-up')) : (S.hasEmail ? 'No tries left today' : 'Add your email for more tries');
    var n = $('[data-afa-gate-n]'); if (n) n.textContent = String(S.emailTries);
  }
  function showErr(m) { var e = $('[data-afa-err]'); if (!e) return; e.textContent = m || ''; e.hidden = !m; }
  function busy(on, text) {
    S.busy = on;
    [].forEach.call(ui.host.querySelectorAll('button, input, textarea'), function (x) { if (!x.hasAttribute('data-afa-keep')) x.disabled = on; });
    var s = $('[data-afa-status]'); clearInterval(S.timer);
    if (!on) { s.hidden = true; s.textContent = ''; $('[data-afa-go]').textContent = 'Design this panel'; return; }
    var t0 = Date.now();
    s.hidden = false;
    var tick = function () { s.textContent = text + ' ' + Math.round((Date.now() - t0) / 1000) + ' s'; };
    tick(); S.timer = setInterval(tick, 1000);
    $('[data-afa-go]').textContent = 'Designing…';
  }
  function readLines() {
    var L = {};
    [].forEach.call(ui.host.querySelectorAll('[data-afa-line]'), function (x) { var k = x.getAttribute('data-afa-line'), v = clean(x.value).slice(0, LIMITS[k]); if (v) L[k] = v; });
    return L;
  }
  function openGate(retry) {
    S.retry = retry;
    $('[data-afa-gate]').hidden = false;
    var e = $('[data-afa-email]'); if (e) { e.value = email || ''; try { e.focus(); } catch (er) {} }
  }
  function useEmail() {
    var v = clean($('[data-afa-email]').value).toLowerCase();
    if (!validEmail(v)) { showErr('Please type a valid email.'); return; }
    email = v; store('wsIdeaEmail', v); S.hasEmail = true;
    $('[data-afa-gate]').hidden = true;
    quota().then(function () { var r = S.retry; S.retry = null; if (r) r(); });
  }

  // ---------- generate 4 previews, show them, make the picked one print-ready and put it on the panel ----------
  function generate() {
    if (S.busy || S.off) return;
    var lines = readLines();
    if (!lines.headline) { showErr('Type the main words for this panel.'); var h = $('[data-afa-line="headline"]'); if (h) h.focus(); return; }
    if (S.left === 0 && !S.hasEmail) { openGate(generate); return; }
    showErr('');
    var p = plan(), notes = clean($('[data-afa-notes]').value).slice(0, LIMITS.notes);
    busy(true, 'Designing your ' + p.panelName.toLowerCase() + '… this takes about a minute.');
    uploadLogo().then(function (logoId) {
      return botToken().then(function (token) {
        var body = withEmail({ visitor: visitor, token: token, widthFt: p.widthFt, heightFt: p.heightFt, style: S.style, styleNotes: notes, lines: lines });
        if (logoId) body.logoId = logoId;
        return api('/api/banner/generate', body, 240000);
      });
    }).then(function (j) {
      busy(false);
      if (j.bannersLeft != null) S.left = j.bannersLeft;
      if ('hasEmail' in j) S.hasEmail = !!j.hasEmail;
      syncQuota();
      if (!j.ok || !j.images || !j.images.length) {
        if (j.error === 'need_email') { S.left = 0; syncQuota(); openGate(generate); return; }
        showErr(j.message || 'We couldn\'t make your designs this time. Please try again.');
        return;
      }
      S.batch = { images: j.images.slice(0, 4), rot: 0, key: p.c.key, panel: p.panel, panelName: p.panelName, logoId: S.logoId || '', lines: lines };
      track('ardor_table_ai_generated', { cover: p.c.key, panel: p.panel });
      showResults();
    }, function (err) {
      busy(false);
      showErr((err && err.message) || 'We couldn\'t upload your logo. Try another file, or remove it and try again.');
    });
  }
  function showResults() {
    var box = $('[data-afa-results]'), b = S.batch; box.textContent = '';
    if (!b) return;
    box.appendChild(el('p', 'abl-help', 'Tap a design to put it on the ' + b.panelName.toLowerCase() + '.'));
    var grid = el('div', 'afa-grid');
    b.images.forEach(function (im, i) {
      var card = el('button', 'afa-card');
      card.type = 'button'; card.setAttribute('data-afa-use', im.id); card.setAttribute('aria-label', 'Use design ' + (i + 1));
      card.innerHTML = '<span class="afa-card__img"><img alt="" loading="lazy" src="' + esc(im.url) + '"></span><span class="afa-card__go">Use this design</span>';
      grid.appendChild(card);
    });
    box.appendChild(grid);
  }
  function useDesign(id) {
    if (S.busy || !S.batch) return;
    var b = S.batch, img = b.images.filter(function (x) { return x.id === id; })[0];
    if (!img) return;
    showErr('');
    busy(true, 'Making a sharp, print-ready version… about 30 to 60 seconds.');
    botToken().then(function (token) {
      return api('/api/banner/final', withEmail({ visitor: visitor, token: token, imageId: id }), 420000);
    }).then(function (j) {
      if (!j.ok || !j.image || !j.image.id) {
        busy(false);
        if (j.error === 'need_email') { openGate(function () { useDesign(id); }); return; }
        showErr(j.message || 'We couldn\'t make the print version. Please try again.');
        return;
      }
      var fin = j.image, lb = (fin.check && fin.check.logoBox) || (img.check && img.check.logoBox) || null;
      var L = window.ArdorTableLayers;
      if (!L || !L.placeAi) { busy(false); showErr('Please reload the page and try again.'); return; }
      return L.placeAi({ id: fin.id, panel: b.panel, rot: 0, logo: b.logoId, lb: lb }).then(function () {
        busy(false);
        track('ardor_table_ai_design_used', { cover: b.key, panel: b.panel });
        if (L.closeDrawer) L.closeDrawer();
        var t = root.querySelector('[data-abb-toast]');
        if (t) { t.textContent = b.logoId ? 'Your AI design is on the ' + b.panelName.toLowerCase() + '. Tap "Use my exact logo" to put your original logo over the AI\'s version.' : 'Your AI design is on the ' + b.panelName.toLowerCase() + '. Move it, resize it, copy it to other panels, or add text and clipart.'; t.hidden = false; setTimeout(function () { t.hidden = true; }, 8000); }
      });
    }).catch(function () { busy(false); showErr('We couldn\'t put the design on your table cover. Please try again.'); });
  }

  // ---------- start: wait for the designer and the drawer ----------
  var tries = 0;
  (function wait() {
    var host = root.querySelector('[data-afa-host]');
    if (host && FA() && window.ArdorTableLayers) { build(host); window.ArdorTableAI = { plan: plan, quota: quota, state: S }; return; }
    if (++tries < 200) setTimeout(wait, 100);
  })();
})();
